import { getLang as documentUtilsGetLang } from '@utils/documentUtils';
import { dateUtils } from '@/utils';
import { dateConstants } from '@/utils/constants';

export default function date(
    value,
    format = dateConstants.FORMAT.DATE_SHORT,
    language = documentUtilsGetLang()
) {
    if (!value) {
        return '';
    }
    if (Object.prototype.toString.call(value) === '[object Date]') {
        return dateUtils.format(value, format, language);
    }

    return dateUtils.format(dateUtils.parseString(value), format, language);
}
